module.exports = __webpack_public_path__ + "static/media/pos-asuransi-white.31893635.svg";


//////////////////
// WEBPACK FOOTER
// ./src/component/pos-asuransi-white.svg
// module id = 367
// module chunks = 2